import type { ReactNode } from 'react';

export function SectionSummary({ children }: { children: ReactNode }) {
  return (
    <div className="mb-6 border-l-2 border-action-primary-bg pl-4 text-text-secondary md:text-[17px]">
      {children}
    </div>
  );
}
